import { gql } from '@apollo/client'

export const GET_MAJOR_SERIES_DATA = gql`
  query GetMajorSeriesData($input: getSeriesVenuesInput!) {
  getMajorSeriesData(input: $input) {
    aSeriesStandings {
      _id
      nLoss
      nNetrr
      nPlayed
      nPoints
      nRunFor
      nWin
      nNR
      oTeam {
        _id
        sCountry
        sTitle
        oImg {
          sUrl
        }
        oSeo {
          sSlug
        }
        sAbbr
      }
      oRound {
        sName
      }
    }
    aCaptains {
     _id
      sFullName
      oImg {
        sUrl
      }
      sTitle
      oSeo {
        sSlug
        _id
      }
      sCountry
      sCountryFull
      sNationality
      oFlag {
        sUrl
      }
      oTeam {
        sAbbr
      }
    }
    aInfo {
      sTitle
      sValue
    }
    aFixtures {
      _id
      sTitle
      sSubtitle
      sFormatStr
      nLatestInningNumber
      sResult
      oTeamScoreA {
        oTeam {
          oImg {
            sUrl
          }
          sAbbr
        }
        sScores
        sOvers
        sScoresFull
      }
      oTeamScoreB {
        oTeam {
          oImg {
            sUrl
          }
          sAbbr
        }
        sScores
        sOvers
        sScoresFull
      }
      sStatusStr
      oVenue {
        sLocation
        oSeo {
          sSlug
          _id
        }
      }
      dStartDate
      dStartTimestamp
      oSeo {
        sSlug
      }
      oCustomStatus {
        sText
      }
      oLiveGameStatus {
        sText
        sValue
      }
      oStatus {
        sText
      }
    }
    aTeams {
      _id
      sTitle
      oImg {
        sUrl
      }
      oSeo {
        sSlug
      }
      sGrouptTitle
    }
    aVenues {
      _id
      sName
      sLocation
      sCountry
      oSeo {
        _id
        sDescription
        sSlug
      }
    }
  }
}
`

export const GET_MAJOR_SERIES_DATA_FIXTURE = gql`
    query GetMajorSeriesData($input: getSeriesVenuesInput!) {
  getMajorSeriesData(input: $input) {
    aFixtures {
      _id
      sTitle
      sSubtitle
      sFormatStr
      nLatestInningNumber
      sResult
      oTeamScoreA {
        oTeam {
          oImg {
            sUrl
          }
          sAbbr
        }
        sScores
        sOvers
        sScoresFull
      }
      oTeamScoreB {
        oTeam {
          oImg {
            sUrl
          }
          sAbbr
        }
        sScores
        sOvers
        sScoresFull
      }
      sStatusStr
      oVenue {
        sLocation
        oSeo {
          sSlug
          _id
        }
      }
      dStartDate
      dStartTimestamp
      oSeo {
        sSlug
      }
    }
  }
}
`
